import { render, staticRenderFns } from "./ModalAssignPatient.vue?vue&type=template&id=2ca1be77&"
import script from "./ModalAssignPatient.vue?vue&type=script&lang=js&"
export * from "./ModalAssignPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports